
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetrimbeshkerbest() {



    const cardData =
    {
        keyword: 'Pune Trimbakeshwar Best Cab',
        heading: 'Mauli Cabs: Pune Trimbakeshwar Best Cab',
        headingDescription: 'Mauli Cabs offers the best cab service from Pune to Trimbakeshwar, ensuring a comfortable and spiritual journey to one of the holiest Jyotirlingas. Whether you are traveling for a pilgrimage, a peaceful retreat, or a family trip, we provide a range of vehicles including sedans, SUVs, and premium cars to suit your needs. With professional drivers, transparent pricing, no hidden charges, and a commitment to safety, Mauli Cabs guarantees a smooth and hassle-free ride to Trimbakeshwar from Pune.',

        top: 'Top Places to Visit in Trimbakeshwar with Mauli Cabs',

"topPlaces": [
    {
        "title": "Trimbakeshwar Temple",
        "description": "The Trimbakeshwar Temple is one of the twelve Jyotirlingas, dedicated to Lord Shiva. It is located at the base of the Brahmagiri Hill in Trimbak, Nashik. The temple is renowned for its architectural beauty and its significance as a major pilgrimage site."
    },
    {
        "title": "Brahmagiri Hill",
        "description": "Brahmagiri Hill, where the Trimbakeshwar Temple is located, is considered a sacred hill in Hinduism. It is believed that Lord Brahma performed penance here. The hill is also a popular trekking destination."
    },
    {
        "title": "Godavari River",
        "description": "The Godavari River originates near Trimbakeshwar Temple, making the place even more sacred. The river is an important part of religious rituals, and devotees often take a dip here as part of their pilgrimage."
    },
    {
        "title": "Trimbakeshwar Fort",
        "description": "The Trimbakeshwar Fort is an ancient fort located in the area surrounding the temple. It offers panoramic views of the surrounding landscape and is a great spot for history and nature lovers."
    },
    {
        "title": "Kushavarta Lake",
        "description": "Kushavarta Lake, situated near the Trimbakeshwar Temple, is considered one of the holiest spots in the region. Pilgrims visit this lake for ritual bathing and to offer prayers to Lord Shiva."
    },
    {
        "title": "Panchavati",
        "description": "Panchavati, a sacred area in Nashik, is believed to be where Lord Rama, along with his wife Sita and brother Lakshmana, spent part of their exile. It is an important religious site, known for its temples and ashrams."
    },
    {
        "title": "Saptashrungi",
        "description": "Saptashrungi is a mountain peak located not far from Trimbakeshwar and is home to the Saptashrungi Devi Temple. It is one of the 51 Shakti Peethas and attracts many devotees seeking blessings from Goddess Saptashrungi."
    },
    {
        "title": "Anjneri Hill",
        "description": "Anjneri Hill, located near Trimbakeshwar, is believed to be the birthplace of Lord Hanuman. It is a popular spot for trekking and offers stunning views of the surrounding region."
    },
    {
        "title": "Nashik",
        "description": "Nashik, a city near Trimbakeshwar, is known for its religious significance and its association with Hindu mythology. It is also famous for its vineyards and wine tourism, making it a unique blend of spirituality and modern tourism."
    },
    {
        "title": "Shree Someshwar Temple",
        "description": "Located near Trimbakeshwar, the Shree Someshwar Temple is dedicated to Lord Shiva. The temple is known for its peaceful atmosphere and scenic surroundings, making it a great place for spiritual reflection."
    }
],

"services": [
    {
        "name": "Pune to Trimbakeshwar Best Cab Service",
        "description": "Mauli Cabs offers the best cab service from Pune to Trimbakeshwar, ensuring a smooth, comfortable, and timely journey to this sacred destination. Travel with peace of mind and reliability."
    },
    {
        "name": "Book Pune to Trimbakeshwar Taxi",
        "description": "Book your taxi from Pune to Trimbakeshwar with Mauli Cabs. We offer easy and hassle-free booking services for a comfortable ride to this sacred pilgrimage site."
    },
    {
        "name": "Affordable Pune to Trimbakeshwar Cab",
        "description": "Mauli Cabs provides affordable taxi services from Pune to Trimbakeshwar, ensuring a budget-friendly and comfortable journey to the holy Trimbakeshwar temple."
    },
    {
        "name": "Private Taxi for Trimbakeshwar from Pune",
        "description": "Travel privately to Trimbakeshwar from Pune with Mauli Cabs. We offer personalized services to ensure a peaceful and comfortable journey to the Trimbakeshwar temple."
    },
    {
        "name": "Trimbakeshwar Pilgrimage Taxi from Pune",
        "description": "Mauli Cabs provides reliable taxi services for your Trimbakeshwar pilgrimage. Travel in comfort and safety, with professional drivers guiding your spiritual journey."
    },
    {
        "name": "Pune to Trimbakeshwar One-Way or Round Trip",
        "description": "Mauli Cabs offers both one-way and round-trip taxi services from Pune to Trimbakeshwar, giving you flexibility in your travel plans for a seamless experience."
    },
    {
        "name": "Comfortable Taxi Service to Trimbakeshwar",
        "description": "Enjoy a comfortable and smooth taxi ride from Pune to Trimbakeshwar with Mauli Cabs. Our well-maintained vehicles ensure a pleasant and safe journey to the temple."
    },
    {
        "name": "Group Travel to Trimbakeshwar",
        "description": "Mauli Cabs offers spacious vehicles for group travel from Pune to Trimbakeshwar. Travel with your family or friends comfortably, ensuring a stress-free journey."
    },
    {
        "name": "Luxury Taxi for Trimbakeshwar Trip",
        "description": "Travel in luxury to Trimbakeshwar from Pune with Mauli Cabs' premium taxi services. Enjoy a plush and stylish ride with top-notch amenities on your pilgrimage trip."
    },
    {
        "name": "Trimbakeshwar Tour by Taxi",
        "description": "Mauli Cabs offers taxi services for a complete Trimbakeshwar tour, ensuring a relaxing and enjoyable visit to the sacred temple and its surroundings."
    }
],

"tableData": [
    ["Pune to Trimbakeshwar Best Cab Service", "Book Pune to Trimbakeshwar Taxi"],
    ["Affordable Pune to Trimbakeshwar Cab", "Private Taxi for Trimbakeshwar from Pune"],
    ["Trimbakeshwar Pilgrimage Taxi from Pune", "Pune to Trimbakeshwar One-Way or Round Trip"],
    ["Comfortable Taxi Service to Trimbakeshwar", "Group Travel to Trimbakeshwar"],
    ["Luxury Taxi for Trimbakeshwar Trip", "Trimbakeshwar Tour by Taxi"]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs provides reliable and timely service for your Pune to Trimbakeshwar journey. Our drivers ensure that you are picked up and dropped off on time, so you can visit the sacred Trimbakeshwar temple without any delays."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "For your Pune to Trimbakeshwar trip, we offer a range of vehicles, including sedans, SUVs, and premium cars. All vehicles are air-conditioned, spacious, and well-maintained, ensuring a comfortable and smooth ride for your spiritual journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced and professional drivers are familiar with the best routes to Trimbakeshwar. They ensure a safe, smooth, and efficient journey while following the best traffic patterns, so you can enjoy a stress-free trip."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers affordable and transparent pricing for your Pune to Trimbakeshwar cab. We ensure clear, upfront pricing with no hidden charges, so you can focus on your journey and not worry about unexpected costs."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Safety is our top priority. All our vehicles are regularly serviced and equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers adhere to strict safety protocols to ensure a secure and comfortable ride."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Trimbakeshwar trip. Whether you need an early morning departure or a late-night return, our customer service team is ready to assist you with your booking at any time of day or night."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Trimbakeshwar cab with Mauli Cabs is quick and easy. You can book your ride online through our website or mobile app, or contact our customer service team for personalized assistance with your booking."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your Pune to Trimbakeshwar trip. Whether you're visiting for a religious pilgrimage or a peaceful retreat, we can tailor the journey to suit your needs and preferences."
    }
]

















    }



    const faqData = [
        {
            question: 'How do I book a cab from Pune to Trimbakeshwar with Mauli Cabs?',
            answer: 'Booking your cab to Trimbakeshwar is simple! You can book directly through our website or mobile app. Just enter Pune as your pickup location and Trimbakeshwar as your destination, then choose the vehicle that suits your needs. Alternatively, you can call our support team for assistance with your booking.',
        },
        {
            question: 'What types of cabs are available for the Pune to Trimbakeshwar trip?',
            answer: 'Mauli Cabs offers a variety of vehicles for your trip to Trimbakeshwar, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. You can select the vehicle that fits your group size, comfort preferences, and budget.',
        },
        {
            question: 'Is the fare for the Pune to Trimbakeshwar trip fixed?',
            answer: 'Yes, the fare is fixed and transparent. It includes tolls, taxes, and driver charges, so there are no hidden costs. The total fare is provided upfront before you confirm your booking.',
        },
        {
            question: 'How long does the journey from Pune to Trimbakeshwar take?',
            answer: 'The journey from Pune to Trimbakeshwar typically takes around 4 to 5 hours, depending on traffic and road conditions. Our drivers ensure a smooth and timely journey for you.',
        },
        {
            question: 'Are the drivers experienced with the Pune to Trimbakeshwar route?',
            answer: 'Yes, Mauli Cabs drivers are experienced with the Pune to Trimbakeshwar route. They are familiar with the best roads to take, ensuring a safe, comfortable, and timely journey to the temple.',
        },
        {
            question: 'Can I book a round trip from Pune to Trimbakeshwar?',
            answer: 'Yes, you can easily book a round trip to Trimbakeshwar. Just provide your return details when booking, and we will ensure that you have a comfortable journey back to Pune.',
        },
        {
            question: 'Can I make stops for sightseeing along the way to Trimbakeshwar?',
            answer: 'Yes, you can customize your trip by making stops for sightseeing along the way to Trimbakeshwar. Whether you want to visit nearby attractions or take a short break, we can tailor your journey according to your preferences.',
        },
        {
            question: 'Are the cabs air-conditioned and comfortable?',
            answer: 'Yes, all our cabs are fully air-conditioned and well-maintained for cleanliness and comfort. We ensure a pleasant and comfortable ride for your journey to Trimbakeshwar.',
        },
        {
            question: 'Can I cancel or modify my booking after confirmation?',
            answer: 'Yes, you can cancel or modify your booking. We offer a flexible cancellation policy via our website or app, and our customer support team is available to assist you at any time.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Trimbakeshwar trip?',
            answer: 'Mauli Cabs offers competitive pricing, a range of vehicle options, professional drivers, and timely service. We ensure a smooth, comfortable, and stress-free experience for your trip to Trimbakeshwar.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Santosh Patil",
            position: "Devotee",
            text: "The trip to Trimbakeshwar with Mauli Cabs was wonderful! The driver was courteous, the car was comfortable, and the whole journey was smooth. We were able to visit the temple without any worries, thanks to Mauli Cabs. Highly recommended for anyone traveling to Trimbakeshwar!",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Shubhangi Desai",
            position: "Spiritual Traveler",
            text: "Mauli Cabs made our journey to Trimbakeshwar a memorable one. The vehicle was clean, the driver was professional, and the entire experience was hassle-free. I would definitely recommend Mauli Cabs for anyone planning to visit Trimbakeshwar!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Trimbakeshwar Best Cab by Mauli Cabs",
        "description": "Mauli Cabs offers the best cab services from Pune to Trimbakeshwar for your pilgrimage trip. Choose from affordable, private, luxury, or group taxis for a one-way or round-trip journey. Enjoy a comfortable and smooth ride with 24x7 online booking support.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.9",
          "ratingCount": "4700"
        }
      };
      
      
      

    return (
        <div>
            <GTag/>


<Helmet>
        <title>Pune to Trimbakeshwar Best Cab | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Trimbakeshwar cab with Mauli Cabs. Choose from affordable, private, luxury, and group taxi options for one-way or round-trip travel. Enjoy a reliable and comfortable ride with 24x7 online booking."
        />
        <meta
          name="keywords"
          content="Pune to Trimbakeshwar best cab service, Book Pune to Trimbakeshwar taxi, Affordable Pune to Trimbakeshwar cab, Private taxi for Trimbakeshwar from Pune, Trimbakeshwar pilgrimage taxi from Pune, Pune to Trimbakeshwar one-way or round trip, Comfortable taxi service to Trimbakeshwar, Group travel to Trimbakeshwar, Luxury taxi for Trimbakeshwar trip, Trimbakeshwar tour by taxi"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>

            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/18.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetrimbeshkerbest;